import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Session } from '@app/store/models/session.model';

import { User } from '@core/objects/user';

import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

/**
 * @deprecated we should use new app version since 12/10/2026
 */
@Component({
    selector: 'profile-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProfileMainComponent implements OnInit{
    // private readonly ACCESS = 'access_setting_workflows_access';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 2;

	public access:boolean = true;
    public status: number = 0;

    public form: FormGroup;
    public user: User = null;
    private subscriptor: Subscription;
    public passwordRequested: boolean = false;

    public showAvatarEditor: boolean = false;
    public showSaved: boolean = false;
    public saving: boolean = false;


	constructor(public app: AppService, private title: TitleService, private formBuilder: FormBuilder){}

	ngOnInit(){
        this.title.set("Profile");
        this.init();

        if(this.user != null ){
            this.status = this.STATUS_DONE;
        }
    }

    init(){
        this.app.getSession().subscribe( (session: Session) => {
            if (this.saving){
                this.showSaved = true;
            }
            this.user = session.current.user;
        });

        this.form = this.formBuilder.group({
            name: [this.user.name, [Validators.required]],
            email: [{ value: this.user.email, disabled: true }]
        });
    }

    save(){
        if(this.form.invalid)
			return;
        this.saving = true;
        this.app.updateUser(this.form.value.name);
    }

    onSavedDone(event){
        this.saving = false;
        this.showSaved = false;
    }

    changePassword(){
        this.app.resetPassword(this.user.email).subscribe({ 
            next: (data: HttpResponse<any>) => {
                this.passwordRequested = true;
            },
            error: (error: HttpErrorResponse) => {
                console.debug("Reset password request error: ", error);
            }
        });
	}

    public openAvatarEditor(){
        this.showAvatarEditor = true;
    }


    public closeAvatarEditor(){
        this.showAvatarEditor = false;
    }

    public formChanged(){
        return (
            this.user.name != this.form.value.name 
        );
    }

}
